/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Favorites_TitleInputs */

const en_favorites_title = /** @type {(inputs: Favorites_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favorites`)
};

const es_favorites_title = /** @type {(inputs: Favorites_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Favoritos`)
};

/**
* | output |
* | --- |
* | "Favorites" |
*
* @param {Favorites_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const favorites_title = /** @type {((inputs?: Favorites_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Favorites_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_favorites_title(inputs)
	return es_favorites_title(inputs)
});